import {
  Code,
  FileCheck2,
  GraduationCap,
  Medal,
  SwatchBook,
  Timer,
} from 'lucide-react';

import { cn } from '@workspace/shadcn';

import { Section } from '../components/section.tsx';

const features = [
  {
    title: 'Expert Instructors',
    icon: GraduationCap,
    description:
      'Learn from world-class, industry professionals with years of experience.',
  },
  {
    title: 'Efficient Learning Experience',
    icon: Timer,
    description:
      'Online courses with live sessions and direct communication with instructors, for maximum learning outcome.',
  },
  {
    title: 'Practical Skills',
    icon: Code,
    description:
      'Gain hands-on experience with real-world projects and study cases.',
  },
  {
    title: 'Industry-Recognized Certifications',
    icon: Medal,
    description:
      'Earn certificates that boost your credibility in the job market.',
  },
  {
    title: 'Specialized Curriculum',
    icon: FileCheck2,
    description:
      'Customized based on the local and regional market demands, yet keeping up with international trends.',
  },
  {
    title: 'Diversity of Themes',
    icon: SwatchBook,
    description:
      'Courses are diverse to serve all aspects of your career needs, from deep technical concepts to business and management skills.',
  },
];

export function Features() {
  return (
    <Section>
      <h2 className="text-4xl font-bold tracking-tighter">
        Why Choose Our Courses?
      </h2>
      <p className="text-muted-foreground my-4 max-w-[640px]">
        Each of our specialized courses is guaranteed to be a stepping stone in
        an excelling career as a healthcare professional.
      </p>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {features.map((feature, index) => (
          <div
            key={feature.title}
            className={cn(
              'group/feature relative flex flex-col border-b py-8 md:border-b-0 md:border-l lg:border-r dark:border-neutral-800',
              (index === 0 || index === 3) && 'lg:border-l dark:border-neutral-800',
              index < 3 && 'lg:border-b dark:border-neutral-800',
            )}
          >
            <div
              className={cn(
                'pointer-events-none absolute inset-0 h-full w-full opacity-0 transition duration-200 group-hover/feature:opacity-100',
                index < 3
                  ? 'bg-gradient-to-t from-neutral-100 to-transparent dark:from-neutral-800'
                  : 'bg-gradient-to-b from-neutral-100 to-transparent dark:from-neutral-800',
              )}
            />
            <div className="relative z-10 mb-4 px-10">
              <feature.icon className="text-foreground size-8" />
            </div>
            <div className="relative z-10 mb-2 px-10 text-lg font-bold">
              <div className="group-hover/feature:bg-primary absolute inset-y-0 left-0 h-6 w-1 origin-center rounded-tr-full rounded-br-full bg-neutral-300 transition-all duration-200 group-hover/feature:h-8 dark:bg-neutral-700" />
              <span className="text-foreground inline-block transition duration-200 group-hover/feature:translate-x-2">
                {feature.title}
              </span>
            </div>
            <p className="text-muted-foreground relative z-10 px-10 text-sm">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </Section>
  );
}
